export default __webpack_public_path__ + "static/media/cooking.aadb3c4a.mp4";